import gradeType from "./hashtagType";
    
    export const successFetchedHashtag =(data)=>({
        type: gradeType.SUCCESS_FETCHIED_HASHTAG,
        payload: data
         })
        export const failureFetchedHashtag =(data)=>({
        type: gradeType.FAILURE_FETCHED_HASHTAG,
        errorMessage: data
         })